import React, { useContext, useEffect, useState } from "react";
import Breadcrumb from "../../../CommonComponents/BreadCrumb/BreadCrumb";
import { SubscriptionPeriodArr } from "../../../../hooks/utils";
import { csrfToken } from "../../../../utis/csrfTokenUtils";
import { networkService } from "../../../config/axios";
import UserInfoContext from "../../../../utis/userInfoContext";
import { AdminFormInput, AdminModalFooter } from "../../../Admin/Shared";
import "../admin.css";

const AddSubscriptionPage = (props) => {
  const { edit_subscription, type } = props
  const { setShowNotifications } = useContext(UserInfoContext)
  const [subscription, setSubscription] = useState({
    name: '',
    description: '',
    product_id: '',
    period: '',
    amount: '',
    currency: '',
    discount: '',
    payment_url: '',
  })
  const [error, setError] = useState({})

  const handleChange = ({ target: { name, value } }) => {
    setError({
      [name]: '',
    })
    setSubscription({
      ...subscription,
      [name]: value
    });
  }

  const handleValidations = (subscription) => {
    let hasError = false;
    const newErrors = {};

    if (!subscription?.name) {
      newErrors.name = "Please add the Subscription name";
      hasError = true;
    }
    if (!subscription?.product_id) {
      newErrors.product_id = "Please enter the product ID";
      hasError = true;
    }
    if (!subscription?.period) {
      newErrors.amount = "Please enter the Period";
      hasError = true;
    }
    if (!subscription?.amount) {
      newErrors.amount = "Please enter the amount";
      hasError = true;
    }
    if (!subscription?.currency) {
      newErrors.currency = "Please enter the currency";
      hasError = true;
    }
    if (!subscription?.discount) {
      newErrors.discount = "Please enter the discount";
      hasError = true;
    }
    if (!subscription?.payment_url) {
      newErrors.payment_url = "Please enter the payment URL";
      hasError = true;
    }

    if (hasError) {
      setError({ ...error, ...newErrors });
      return false;
    } else {
      return true;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (handleValidations(subscription)) {
      const data = {
        authenticity_token: csrfToken(),
        ...(edit_subscription && { id: edit_subscription?.id }),
        subscription: {
          name: subscription?.name,
          description: subscription?.description,
          product_id: subscription?.product_id,
          period: subscription?.period,
          amount: subscription?.amount,
          currency: subscription?.currency,
          discount: subscription?.discount,
          payment_url: subscription?.payment_url,
        }
      }
      if (!subscription?.name) {
        setError({ ...error, name: 'Please add the organisation name' })
      }
      const url = edit_subscription?.id ? `admin/subscriptions/${edit_subscription?.id}.json` : 'admin/subscriptions.json'
      await networkService(url, edit_subscription?.id ? 'PATCH' : 'POST', data).
        then((response) => {
          if (response.status == 200 || response?.status === 201) {
            window.location.href = '/admin/subscriptions'
            setShowNotifications({
              showToast: true,
              toastType: "success",
              toastMessage: `Subscription ${edit_subscription?.id ? 'Updated' : 'Added'}`,
            })
          }
        }).
        catch((error) => {
          setShowNotifications({
            showToast: true,
            toastType: 'danger',
            toastMessage: "Something went wrong"
          })
        });
    }
  }

  useEffect(() => {
    setSubscription(edit_subscription)
  }, [edit_subscription])

  return (
    <div className="admin-module">
      <div className="admin-subscription-page admin-content">
        <Breadcrumb string={`Admin / Subscriptions / ${type === "edit" ? "Update" : "Add"}`} />
        <div className="container admin-subscription-container d-flex justify-content-center">
          <form onSubmit={handleSubmit} className="admin-form-page">
            <AdminFormInput
              label="Name"
              name="name"
              placeholder="Name"
              value={subscription?.name ?? ""}
              onChange={handleChange}
              required
              type="text"
              error={error?.name}
            />
            <AdminFormInput
              label="Description"
              name="description"
              placeholder="Description"
              value={subscription?.description ?? ""}
              onChange={handleChange}
              type="text"
            />
            <div className="admin-form-row">
              <AdminFormInput
                label="Thrive product id"
                name="product_id"
                placeholder="Product ID"
                value={subscription?.product_id ?? ""}
                onChange={handleChange}
                required
                type="text"
                error={error?.product_id}
              />
              <div className="admin-form-group">
                <label htmlFor="period" className="admin-form-label">
                  Period <span className="text-danger ms-1">*</span>
                </label>
                <select
                  id="period"
                  name="period"
                  value={subscription?.period ?? ""}
                  onChange={handleChange}
                  className="admin-form-input"
                >
                  <option value="">Select period</option>
                  {SubscriptionPeriodArr?.map((option, idx) => (
                    <option key={idx} value={option?.value}>
                      {option?.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="admin-form-row admin-form-row-three">
              <AdminFormInput
                label="Amount"
                name="amount"
                placeholder="Amount"
                value={subscription?.amount ?? ""}
                onChange={handleChange}
                required
                type="text"
                error={error?.amount}
              />
              <AdminFormInput
                label="Currency"
                name="currency"
                placeholder="Currency"
                value={subscription?.currency ?? ""}
                onChange={handleChange}
                required
                type="text"
                error={error?.currency}
              />
              <div className="admin-form-group">
                <label htmlFor="discount" className="admin-form-label">
                  Discount <span className="text-danger ms-1">*</span>
                </label>
                <div className="admin-input-append-wrapper">
                  <input
                    id="discount"
                    name="discount"
                    type="text"
                    placeholder="Discount"
                    value={subscription?.discount ?? ""}
                    onChange={handleChange}
                    className={`admin-form-input ${error?.discount ? "has-error" : ""}`}
                  />
                  <span className="admin-input-append">%</span>
                </div>
                {error?.discount && <p className="admin-form-error">{error.discount}</p>}
              </div>
            </div>
            <AdminFormInput
              label="Payment URL"
              name="payment_url"
              placeholder="Payment URL"
              value={subscription?.payment_url ?? ""}
              onChange={handleChange}
              required
              type="text"
              error={error?.payment_url}
            />
            <AdminModalFooter
              onCancel={() => (window.location.href = "/admin/subscriptions")}
              onSubmit={(e) => {
                e.preventDefault();
                handleSubmit(e);
              }}
              cancelText="Back"
              submitText={edit_subscription?.id ? "Update Subscription" : "Create Subscription"}
              submitType="submit"
            />
          </form>
        </div>
      </div>
    </div>
  );
};
export default AddSubscriptionPage;
